export const createActivityTag = `mutation MyMutation(
			$hotelId: String!
			$name: String!
	    $language:String
		) {
			createActivityTag(
				input: {
					hotelId: $hotelId
					name: $name
	        lang:$language
				}
			) {
				status
				message
			}
		}
	`;

export const updateActivityTag = `mutation MyMutation(
		$hotelId: String!
		$name: String!
		$id: String!
	  $language:String
	) {
		updateActivityTag(
			input: {
				hotelId: $hotelId
				name: $name
				id: $id
	      lang:$language
			}
		){
			id
			hotelId
			name
		  }
	}
`;

export const deleteActivityTag = `mutation MyMutation(
	$hotelId: String!
	$id: String!
	$language:String
) {
	deleteActivityTag(
		input: {
			hotelId: $hotelId
			id: $id
	    lang:$language
		}
	) {
		status
		message
	}
}
`;

export const CreateActivityCalendar = `mutation MyMutation(
  $name: String!
  $tags: [String]!
  $customAttributes: [CustomAttributeInput]
  $description: String!
  $highlights: String
  $hotelId: String!
  $icons: [String]
  $images: [ImagesInput]
  $label: String
  $location: String
  $information: [ActivityInformationInput]
  $activityLocation: ActivityLocationInput!
  $schedule: ActivityScheduleInput!
  $bannerImage: ImagesInput
  $isActive: Boolean!
  $language: String
  $capacity: Int
  $categoryId: String!
  $categoryName: String!
  $price: Float
  $residentsOnly: Boolean!
  $bannerImageStatus: Boolean
  $forChild: Boolean
  $minimumAge: Int
  $gender:  [String]
  $cta: ActivityCTAInput
  $waiver: ActivityWaiverInput
  $maintenanceSchedule: ActivityMaintenanceScheduleInput
) {
  createActivity(
    input: {
      customAttributes: $customAttributes
	    information: $information
      description: $description
      highlights: $highlights
      hotelId: $hotelId
      icons: $icons
      images: $images
      label: $label
      location: $location
      activityLocation: $activityLocation
      name: $name
      schedule: $schedule
      tags: $tags
      bannerImage: $bannerImage
      isActive: $isActive
      lang: $language
      capacity: $capacity
      categoryId: $categoryId
      categoryName: $categoryName
      price: $price
      residentsOnly: $residentsOnly
	    bannerImageStatus: $bannerImageStatus
      forChild: $forChild
      minimumAge: $minimumAge
      gender: $gender
      cta: $cta
      waiver: $waiver
      maintenanceSchedule: $maintenanceSchedule
    }
  ) {
    status
    message
  }
}`;

export const updateActivityList = `
mutation MyMutation(
	$id: String!
	$name: String!
	$tags: [String]!
	$customAttributes : [CustomAttributeInput]
	$information: [ActivityInformationInput]
	$description: String!
	$highlights: String
    $hotelId: String!
	$icons: [String]
	$images: [ImagesInput]
	$label:  String
	$location: String
    $schedule: ActivityScheduleInput!
	$bannerImage: ImagesInput
	$isActive:Boolean
	$language:String
    $capacity: Int
    $categoryId: String!
    $categoryName: String
    $price: Float
    $residentsOnly: Boolean
    $activityLocation: ActivityLocationInput
	  $bannerImageStatus: Boolean
    $forChild: Boolean
    $minimumAge: Int
    $gender:  [String]
    $cta: ActivityCTAInput
    $waiver: ActivityWaiverInput
    $maintenanceSchedule: ActivityMaintenanceScheduleInput
) {
	updateActivity(
    input: {
		customAttributes: $customAttributes
		information: $information
		description: $description
		highlights: $highlights
		hotelId: $hotelId
		icons: $icons
		images: $images
		label: $label
		location: $location
		name: $name
		schedule: $schedule
		tags: $tags
		bannerImage: $bannerImage
	    id: $id
		isActive:$isActive
	    lang:$language
        capacity: $capacity
        categoryId: $categoryId
        categoryName: $categoryName
        price: $price
        residentsOnly: $residentsOnly
        activityLocation: $activityLocation
		    bannerImageStatus: $bannerImageStatus
        forChild: $forChild
        minimumAge: $minimumAge
        gender: $gender
        cta: $cta
        waiver: $waiver
        maintenanceSchedule: $maintenanceSchedule
  }) {
	description
	highlights
	hotelId
	icons
	id
	images {
	 fileName
	 index
	 master
	 ratio16to9
	 ratio1to1
	 ratio9to16
	 ratio21to9
	 ratio9to21
	}
	information {
	 type
	 email
     phone
     URL
     title
     displayTitle
	}
	isActive
	label
	location
	name
  forChild
  minimumAge
  gender
  cta {
      email
      status
      phoneNumber
      title
      type
    }
    waiver {
      status
      messageText
      checkboxes {
        label
      }
    }
    maintenanceSchedule {
      scheduleType
      oneTime {
        date
        startDate
        endDate
        startTime
        endTime
      }
      recurring {
        startDate
        endDate
        recurs
        recursWeek
        dates
        timeSlots {
          startTime
          endTime
        }
        recurrences
      }
    }
	    schedule {
      alwaysActive
      endTime
      oneTime {
        date
      }
      recurring {
        addPadding
        dates
        paddingDuration
        slotDuration
        endDate
        recursWeek
        recurs
        startDate
        recurrences
        totalActivityTime
        recurringTimeSlots{
            startTime
            endTime
            capacity
            paddingDuration
            slotDuration
            gender
            isChild
            audienceType
        }
      }
      scheduleType
      startTime
    }
	tags
    capacity
    categoryId
    categoryName
    price
    residentsOnly
	bannerImageStatus
    activityLocation {
      hotelLocation
      addressLine1
      addressLine2
      area
      city
      country
      latitude
      longitude
      postalCode
      state
      timezone
      url
      urlTitle
      locationType
    }
  }
}`;

export const deleteActivityData = `mutation MyMutation(
	$hotelId: String!
	$id: String!
	$language:String
) {
	deleteActivity(
		input: {
			hotelId: $hotelId
			id: $id
	    lang:$language
		}
	) {
		status
		message
	}
}
`;

export const handleDeactivate = `mutation MyMutation(
	$hotelId: String!
	$id: String!
	$language:String
) {
	updateActivityStatus(
		input: {
			hotelId: $hotelId
			id: $id
	    lang:$language
		}
	) {
		status
		message
	}
}
`;

export const CreateActivityCategory = `mutation MyMutation(
  $hotelId: String!
  $name: String!
  $categoryCode: String!
  $isActive: Boolean
  $customAttributes: [CustomAttributeInput]
  $images: [ImagesInput]!
  $lang: String!
){
  createActivityCategory(
    input: {
      hotelId: $hotelId
      name: $name
      categoryCode: $categoryCode
	  isActive: $isActive
      customAttributes: $customAttributes
	  images: $images
	  lang: $lang
    }
  ) {
    message
    status
  }
}`;

export const UpdateActivityCategory = `mutation UpdateActivityCategory(
  $id: String!
  $hotelId: String!
  $name: String!
  $categoryCode: String!
  $isActive: Boolean
  $lang: String!
  $images: [ImagesInput]!
  $customAttributes: [CustomAttributeInput]
) {
  updateActivityCategory(
    input: {
      id: $id
      hotelId: $hotelId
      name: $name
      categoryCode: $categoryCode
	  isActive: $isActive
      lang: $lang
      images: $images
      customAttributes: $customAttributes
    }
  ) {
    categoryCode
    createdAt
    createdBy
    updatedAt
    updatedBy
    name
    isActive
    images {
      fileName
      index
      master
      ratio16to9
      ratio1to1
      ratio21to9
      ratio9to16
      ratio9to21
    }
    id
    hotelId
    customAttributes {
      key
      value
    }
  }
}
`;

export const DeleteActivityCategory = `mutation DeleteActivityCategory(
	$id: String!,
	$hotelId: String!
	$lang: String!
  ) {
	deleteActivityCategory(
	  input: { id: $id, 
	  hotelId: $hotelId,
	  lang: $lang 
	  }
	) {
	  message
	  status
	}
  }
`;

export const UpdateActivityCategoryStatus = `mutation UpdateActivityCategoryStatus(
	$id: String!,
	$hotelId: String!,
	$lang: String
  ) {
	updateActivityCategoryStatus(
	  input: { id: $id, hotelId: $hotelId, lang: $lang }
	) {
	  message
	  status
	}
  }
`;
